import React, { useState } from "react";

// Lib
import { Link } from "react-router-dom";
import { useAppDispatch } from "lib/hooks/useDispatch";

// Actions
import * as actionsCreator from "../reducer";
import * as actionsCreatorSettings from "../../../reducers/settings";

// Components
import Img from "components/Img";
import Tile from "components/UiKit/Tile";
import Tabs from "components/UiKit/Tabs";
import Loader from "components/UiKit/Loader";

// Type
import { TPrices } from "pages/MoleculeProduct/reducer";

type PropsArg = {
  type: string | number | undefined;
  price: string | number | undefined;
  value: string | number | undefined;
}

// Options select
const options = [
  { label: "USD", value: "Usd" },
  { label: "EUR", value: "Eur" }
];

// Interface
interface IPricesList {
  prices?: TPrices[];
  typePrice?: string;
  currentPrice?: any;
  optionsRadioTypePrices?: { [index: string]: string }[];
}

export const PricesList: React.FC<IPricesList> = (props) => {
  const dispatch = useAppDispatch();
  const { prices, typePrice, currentPrice, optionsRadioTypePrices } = props;

  const currentCurrency = localStorage.getItem("currency") || "Usd";
  const option = options?.find(x => x?.value === currentCurrency) || options[0];

  const countAvailable = prices?.filter(
    (item: TPrices) => !item.available
  )?.length;

  const [current, setCurrent] = useState<any>(currentPrice);

  const handlerClick = (selected: PropsArg): void => {
    setCurrent(selected);
    dispatch(actionsCreator.handlerChangePrice(selected));
  };

  const handlerChangeRadio = (value: string) => {
    dispatch(actionsCreatorSettings.handlerChangeTypePrice(value));
    setCurrent("");
    dispatch(actionsCreator.handlerChangePrice({
      type: "",
      price: "",
      value: ""
    }));
  };

  const getNoData = () => {
    return (
      <div className="prices-list__not-found text-align-cn mt10 mb10">
        <Img name="box" alt="Empty box" className="relative" />
        <p className="prices-list__contact-us mt10">
          Please <Link to="/contact-us">contact us</Link> to get up-to-date prices for the current product.
        </p>
      </div>
    );
  };

  const getList = (data: TPrices[]) => {
    return !!data?.length
      ? data.map((item: TPrices, i: number) =>
        <Tile
          {...item}
          current={current.value}
          onClick={handlerClick}
          key={`${item?.value}_${i}`}
          type={option?.value || ""}
        />
      )
      : <Loader type="circle" color="dark" />;
  };

  const content = getList(prices || []);
  const isNoData = countAvailable === prices?.length;

  const tabs = optionsRadioTypePrices?.length
    ? optionsRadioTypePrices?.map(item => {
      return {
        url: item.value,
        label: item.label,
        content: isNoData ? getNoData() : content
      };
    }) : [];

  const hasMultipleTabs = tabs.length > 1;

  return (
    <div className="prices-list">
      <h4 className="prices-list__title mb10">
        Prices
      </h4>

      {hasMultipleTabs ? (
        <Tabs
          tabs={tabs}
          type="secondary"
          nameKeyTab="price-tab"
          callback={handlerChangeRadio}
          defaultScreen={typePrice || "EBC"}
          classNameContent="prices-list__tiles flex flex-wrap flex-ai-start flex-jc-start flex-jc-between-start-desktop relative mt10"
        />
      ) : (
        <div className="prices-list__tiles flex flex-wrap flex-ai-start flex-jc-start flex-jc-between-start-desktop relative mt10">
          {content}
        </div>
      )}
    </div>
  );
};

export default PricesList;